import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SunMedium, ShieldCheck, Cctv, Check, ArrowUpRight } from "lucide-react";
import { SPECIALIST } from "@/data/site";
import { Reveal, fadeUp, stagger } from "@/lib/motion";
import { AddToEnquiryButton, slugify } from "@/components/site/AddToEnquiryButton";

const ICONS = { SunMedium, ShieldCheck, Cctv };

export const Specialist = () => {
  return (
    <section id="specialist" data-testid="specialist" className="relative z-10 bg-[#08090B] py-24 sm:py-28">
      <div className="container-x">
        <Reveal className="mb-14 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <span className="eyebrow mb-4"><span className="h-px w-8 bg-[var(--blue-bright)]" /> Specialist Services</span>
            <h2 className="font-display text-4xl font-800 leading-tight tracking-tight text-white sm:text-5xl">
              Premium protection &amp; upgrades.
            </h2>
            <p className="mt-4 text-base text-[var(--muted)]">
              Our specialist work — precision tints, self-healing PPF and professional dash cam installs.
            </p>
          </div>
          <Link to="/services" data-testid="specialist-pricing-link" className="btn-ghost shrink-0">
            Full Pricing <ArrowUpRight size={16} />
          </Link>
        </Reveal>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
          className="grid gap-5 lg:grid-cols-3">
          {SPECIALIST.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div key={s.title} variants={fadeUp} data-testid={`specialist-${s.title.split(" ")[0].toLowerCase()}`}
                className="group relative overflow-hidden rounded-3xl border border-[var(--blue)]/25 bg-gradient-to-b from-[#12161C] to-[#0B0E12] p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-[var(--blue-bright)]/60 hover:glow-ring">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[var(--blue-bright)]/60 to-transparent" />
                <div className="mb-6 flex items-center justify-between">
                  <div className="grid h-14 w-14 place-items-center rounded-2xl bg-[var(--blue)]/12 text-[var(--blue-bright)] ring-1 ring-[var(--blue)]/25">
                    <Icon size={26} strokeWidth={1.6} />
                  </div>
                  <span className="rounded-full border border-[var(--blue)]/30 bg-[var(--blue)]/10 px-3.5 py-1.5 text-xs font-semibold text-[var(--blue-bright)]">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-display text-2xl font-800 text-white">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{s.desc}</p>
                <ul className="mt-6 space-y-3 border-t border-[var(--line)] pt-6">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5 text-sm text-[var(--white)]/85">
                      <Check size={16} className="mt-0.5 shrink-0 text-[var(--blue-bright)]" /> {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-6">
                  <AddToEnquiryButton id={`spec-${slugify(s.title)}`} name={s.title} price={s.tag} />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
